import { Sector, useSectorQuery } from 'graphql-common';
import { ApolloError } from '@apollo/client/errors';

type Args = {
  id: string;
};

export type UseSectorQueryHookResult = {
  data: Sector | null | undefined;
  error: ApolloError | undefined;
  firstLoading: boolean;
  loading: boolean;
  refetch: () => Promise<unknown>;
};

export default function useSectorQueryHook(
  args: Args,
): UseSectorQueryHookResult {
  const { id } = args;
  const query = useSectorQuery({
    skip: !id,
    variables: {
      id,
    },
    fetchPolicy: 'cache-and-network',
  });
  const { data: queryData, refetch, loading, error, previousData } = query;
  const data = queryData || previousData;
  const firstLoading = loading && queryData === undefined;

  return {
    data: data?.data as Sector,
    error,
    firstLoading,
    loading,
    refetch,
  };
}
